import Dialog from 'components/Dialog';
import React from 'react';
import {Grid} from '@mui/material';
import FormikTextField from 'components/inputs/FormikTextField';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useDispatch, useSelector} from 'react-redux';
import {layoutActions} from 'features/layout/redux';
import {unpackId} from 'common/diplomatIdUtil';
import {useTranslation} from 'react-i18next';
import {IDiplomatObject} from 'types/DiplomatObject';
import {sftpUserSelectors} from 'redux/sftp-user';
import {pageTypes} from 'features/layout/CommonPage/redux';
import {action} from 'redux/helpers';
import {ISftpUser} from 'types/diplomat/sftp/SftpUser';
import Formik from 'components/hook-form/Formik';

const validationSchema = yup.object({
   userName: yup.string().required(),
});

type Props = {
   data?: INav;
   onClose: () => void;
};

const RenameSftpUserDialog = ({data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const sftpUsers = useSelector(sftpUserSelectors.getSftpUsers);
   const onSuccess = (data: ISftpUser) => {
      dispatch(layoutActions.loadTreeNav());
      dispatch(action(pageTypes.GET_DATA.SUCCESS, data));
      onClose();
   };
   const {id} = unpackId(data?.id);
   const {request} = usePostApi(`${api.sftpUser}/${id}/rename`, {onSuccess, onFailure: onClose});

   const validateName = (value: string) => {
      const isNameExists = sftpUsers.some((obj: IDiplomatObject) => obj.name === value);
      if (isNameExists) {
         return t(`Diplomat MFT already contains a User named {{name}}`, {
            name: value,
         });
      }
   };

   return (
      <Dialog maxWidth="sm" header={t('Rename User')} close={onClose}>
         <Formik
            initialValues={validationSchema.cast({userName: data?.name})}
            onSubmit={(values) => {
               request(null, {searchParams: values});
            }}
         >
            <>
               <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={8}>
                     <FormikTextField
                        autoFocus
                        type="text"
                        name="userName"
                        label={t('New User Name:')}
                        required
                        validate={validateName}
                     />
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <FormFooterButtons cancel={onClose} />
               </Grid>
            </>
         </Formik>
      </Dialog>
   );
};

export default RenameSftpUserDialog;
